import axios from 'axios'
import Vue from 'vue'
import uuid from 'uuid/v1'
import _cloneDeep from 'lodash/cloneDeep'
// import mock from './mocks'
import locale from 'browser-locale'

// if (mock) {console.log(mock)}

let language
if (!window.prwidget.language || window.prwidget.language === '') {
  language = locale()
  language = language.split('-')[0]
} else {
  language = window.prwidget.language
  language = language.split('-')[0]
}

let domain
if (!window.prwidget.domain || window.prwidget.domain === '') {
  domain = window.location.host
} else {
  domain = window.prwidget.domain
}

let page
if (!window.prwidget.page || window.prwidget.page === '') {
  page = window.location.pathname
} else {
  page = window.prwidget.page
}

let scrollTillTheEnd
if (!window.prwidget.scrollTillTheEnd || window.prwidget.scrollTillTheEnd === '') {
  scrollTillTheEnd = 'Scorrere la pagina fino in fondo all\'informativa per attivare le caselle di conferma e procedere'
} else {
  scrollTillTheEnd = window.prwidget.scrollTillTheEnd
}

let ref
if (!window.prwidget.ref || window.prwidget.ref === '') {
  ref = ''
} else {
  ref = window.prwidget.ref
}

let termId
if (!window.prwidget.termId || window.prwidget.termId === '') {
  termId = ''
} else {
  termId = window.prwidget.termId
}

let baseURL
if (!window.prwidget.baseURL || window.prwidget.baseURL === '') {
  baseURL = 'https://privacy.dataone.online'
} else {
  baseURL = window.prwidget.baseURL
}

let bkBaseUrl
if (!window.prwidget.bkBaseUrl || window.prwidget.bkBaseUrl === '') {
  bkBaseUrl = 'https://privacy.dataone.online'
} else {
  bkBaseUrl = window.prwidget.bkBaseUrl
}

let loaded = false
let term = {}
if (!window.prwidget.paragraphs || window.prwidget.paragraphs === '') {
} else {
  term = {
    ownerId: window.prwidget.ownerId,
    paragraphs: _cloneDeep(window.prwidget.paragraphs)
  }
  loaded = true
}

let deferred = '#NO#'
if (window.prwidget.deferred && window.prwidget.deferred !== '') {
  deferred = window.prwidget.deferred
}

let submitClass = ''
if (window.prwidget.submitClass && window.prwidget.submitClass !== '') {
  submitClass = window.prwidget.submitClass
}

let submitAttributes = []
if (window.prwidget.submitAttributes) {
  submitAttributes = window.prwidget.submitAttributes
}

export const state = () => ({
  submitAttributes,
  deferred,
  baseURL,
  id: uuid(),
  loaded,
  ieMode: true, // no complex headers sent if true
  submitCaption: window.prwidget.submitCaption,
  submitClass,
  isAjax: false,
  error: {},
  hasError: false,
  version: '1.0.0 ',
  term,
  scrollTillTheEnd,
  ownerId: window.prwidget.ownerId,
  domain,
  page,
  language,
  termId,
  ref,
  tagNoShow: '##noshow##',
  tagLink: '##link##',
  tagLinkLabel: '##linklabel##',
  tradLinkLabel: {
    'it': 'Leggi l\'informativa completa',
    'en': 'Read the complete information',
    'de': 'Lesen Sie die vollständigen Informationen',
    'fr': 'Lire les informations complètes',
    'es': 'Lea la información completa',
    'ru': 'Читать полную информацию',
    'hu': 'Olvassa el a teljes információt',
    'pl': 'Przeczytaj pełne informacje'
  }
})

const mutations = {
  setScrollTillTheEnd (s, p) { s.scrollTillTheEnd = p },
  setTerm (s, p) { s.term = p },
  setSubmitCaption (s, p) { s.submitCaption = p },
  setId (s, p) { s.id = p },
  setLoaded (s, p) { s.loaded = p },
  setRef (s, p) { s.ref = p },
  setPage (s, p) { s.page = p },
  setDomain (s, p) { s.domain = p },
  setOwnerId (s, p) { s.ownerId = p },
  isAjax (state, payLoad = false) {
    state.isAjax = payLoad
  },
  error (state, payLoad = null) {
    if (payLoad === null) {
      if (state.error !== null) {
        state.error = null
      }
    } else {
      Vue.set(state, 'error', payLoad)
    }
  },
  hasError (state, payLoad = false) {
    state.hasError = payLoad
  }

}

const instance = axios.create({
  baseURL: baseURL + '/api',
  timeout: 10000,
  headers: {'Content-Type': 'application/json'},
  withCredentials: true
})

const bkinstance = axios.create({
  baseURL: bkBaseUrl + '/api',
  timeout: 10000,
  headers: {'Content-Type': 'application/json'},
  withCredentials: true
})

export const actions = {
  init ({state}) {
    console.dir(state)
    // empty
  },
  get ({commit, getters}, {url, options = {}}) {
    if (window.location.host === 'localhost:8080') url = 'https://privacy.dataone.online/api/widget'
    commit('isAjax', true)
    commit('error')
    commit('hasError')

    if (!options.headers) {
      options.headers = {}
    }

    return instance.get(url, options)
      .then(res => {
        commit('isAjax')
        return res
      })
      .catch(err => {
        console.dir(err)

        commit('isAjax')
        commit('error', err)
        commit('hasError', true)
        return Promise.reject(err)
      })
  },
  post ({commit, getters}, {url, data, options = {}, serverName = 'abs'}) {
    commit('isAjax', true)
    commit('error')
    commit('hasError')

    return instance.post(url, data, options)
      .then(res => {
        commit('isAjax')
        return res
      })
      .catch(err => {
        console.log(err)
        commit('isAjax')
        commit('error', err)
        commit('hasError', true)
        return Promise.reject(err)
      })
      .then(() => {
        commit('isAjax', true)
      })
      .catch(e => {
        console.log('---- try backup')
        return bkinstance.post(url, data, options)
          .then(res => {
            commit('isAjax')
            return res
          })
          .catch(err => {
            console.log(err)
            commit('isAjax')
            commit('error', err)
            commit('hasError', true)
            return Promise.reject(err)
          })
      })
  },
  load ({commit, dispatch, state}) {
    if (state.loaded) {
      return
    }

    const url = `/widget`

    const params = {
      ownerId: state.ownerId,
      termId: state.termId,
      page: state.page,
      domain: state.domain,
      ref: state.ref,
      language: state.language
    }

    let pr = JSON.stringify(params)
    pr = encodeURI(btoa(pr))

    const options = {
      params: {_k: pr}
      // headers: {
      //  // OwnerId: state.ownerId,
      //  // TermId: state.termId,
      //  // Domain: state.domain,
      //  // Page: state.page,
      //  // Language: state.language,
      //  Domain: JSON.stringify(params)
      // }
    }

    return dispatch('get', {url, options})
      .then(res => {
        let data = res.data

        for (let i = 0; i < data.paragraphs.length; i++) {
          data.paragraphs[i].scrolled = false
        }
        // if (data)
        commit('setTerm', data)
      })
  },
  save ({commit, dispatch, state, getters}, {cryptedForm, form, record}) {
    let url = `/widget`
    const {ownerId, termId} = state.term
    const flags = getters.allFlags
    let options = {
      headers: {
        OwnerId: ownerId,
        'Content-Type': 'application/json'
      }
    }

    if (state.ieMode) {
      url = `/widgetcomp`
      options = {
        headers: {
          'Content-Type': 'text/plain'
        }
      }
    }
    let term = state.term
    term.language = language

    const data = {
      id: state.id,
      ownerId,
      form,
      cryptedForm,
      deferred: state.deferred,
      record,
      flags,
      termId, //
      domain: state.domain,
      page: state.page,
      language: state.language,
      term: state.term,
      ref: state.ref || ''
    }
    // console.log(url)
    // console.dir(form)
    // console.dir(data)
    // console.dir(options)
    return dispatch('post', {url, options, data}, {root: true})
  }

}

const getters = {
  trackId: s => {
    const t = `do=${s.domain}&pg=${s.page}&ow=${s.ownerId}`
    return 'prvwdg' + btoa(encodeURI(t))
  },
  allFlags: s => {
    if (!s.term || !s.term.paragraphs) {
      return []
    }
    const flags = []
    for (let i = 0; i < s.term.paragraphs.length; i++) {
      let p = s.term.paragraphs[i]
      for (let j = 0; j < p.treatments.length; j++) {
        const {code, selected, mandatory} = p.treatments[j]
        flags.push({code, selected, mandatory, termId: s.termId})
      }
    }
    return flags
  },
  allMandatorySelected: s => {
    if (!s.term || !s.term.paragraphs) {
      return false
    }
    for (let i = 0; i < s.term.paragraphs.length; i++) {
      let p = s.term.paragraphs[i]
      for (let j = 0; j < p.treatments.length; j++) {
        let t = p.treatments[j]
        if (t.mandatory && !t.selected) {
          return false
        }
      }
    }

    return true
  },
  paragraphHasNoMandatoryFlags: s => p => {
    for (let j = 0; j < p.treatments.length; j++) {
      let t = p.treatments[j]
      if (t.mandatory) {
        return false
      }
    }
    return true
  },
  allScrolled: s => {
    if (!s.term || !s.term.paragraphs) {
      return false
    }
    for (let i = 0; i < s.term.paragraphs.length; i++) {
      let p = s.term.paragraphs[i]
      if (!p.scrolled) {
        return false
      }
    }

    return true
  },
  privacyIsValid: (s, g) => {
    if (!g.allScrolled) {
      return false
    }

    return g.allMandatorySelected
  }

}

export const store = {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store.js